import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AttachmentCategory, ApiResponse, PaginatedResponse, DialogCloseResult } from '../../attachment-management/attachment.interface';

@Component({
  selector: 'meu-modal-create-attachment-category',
  templateUrl: './modal-create-attachment-category.component.html',
  styleUrls: ['./modal-create-attachment-category.component.scss']
})
export class ModalCreateAttachmentCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  isLoading = false;
  categoryId: string;
  private apiUrl = environment.backendhost + '/api/attachment_categories';

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalCreateAttachmentCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private toastr: ToastrService,
    private http: HttpClient
  ) {
    this.categoryId = data.id;
  }

  ngOnInit() {
    this.createForm();
    if (this.categoryId) {
      this.loadCategoryDetail();
    }
  }

  createForm() {
    this.categoryForm = this.fb.group({
      name: ['', Validators.required]
    });
  }

  loadCategoryDetail() {
    // Use filter to get by id since API might use code
    this.http.get<ApiResponse<PaginatedResponse<AttachmentCategory>>>(`${this.apiUrl}?Filters=id==${this.categoryId}`).subscribe(
      (res) => {
        if (res.success && res.data && res.data.collection && res.data.collection.length > 0) {
          const category = res.data.collection[0];
          this.categoryForm.patchValue({
            name: category.name
          });
        } else {
          this.toastr.error('Không tìm thấy thông tin thể loại');
        }
      },
      (error) => {
        this.toastr.error('Không thể tải thông tin thể loại');
        console.error('Error loading category:', error);
      }
    );
  }

  onSubmit() {
    if (this.categoryForm.invalid) {
      this.toastr.warning('Vui lòng điền đầy đủ thông tin');
      return;
    }

    this.isLoading = true;
    const data: Partial<AttachmentCategory> = this.categoryForm.value;
    const newName: string = (data.name || '').trim().toLowerCase();

    this.http.get<ApiResponse<PaginatedResponse<AttachmentCategory>>>(
      `${this.apiUrl}?Filters=name==${encodeURIComponent(newName)}&PageSize=100`
    ).subscribe(
      (res) => {
        if (res.success && res.data && res.data.collection) {
          const duplicate = res.data.collection.find(
            (cat) => cat.name.trim().toLowerCase() === newName && cat.id !== this.categoryId
          );
          if (duplicate) {
            this.isLoading = false;
            this.toastr.error(`Thể loại "${data.name}" đã tồn tại. Vui lòng chọn tên khác.`);
            return;
          }
        }
        this.saveCategory(data);
      },
      () => {
        this.saveCategory(data);
      }
    );
  }

  saveCategory(data: Partial<AttachmentCategory>) {
    if (this.categoryId) {
      // Update
      this.http.put<ApiResponse<AttachmentCategory>>(`${this.apiUrl}/${this.categoryId}`, data).subscribe(
        (res) => {
          this.isLoading = false;
          if (res.success) {
            this.dialogRef.close({ event: true, type: 'update' } as DialogCloseResult);
          } else {
            this.toastr.error(res.message || 'Cập nhật thất bại');
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error('Có lỗi xảy ra khi cập nhật thể loại');
        }
      );
    } else {
      // Create
      this.http.post<ApiResponse<AttachmentCategory>>(this.apiUrl, data).subscribe(
        (res) => {
          this.isLoading = false;
          if (res.success) {
            this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
          } else {
            this.toastr.error(res.message || 'Tạo thất bại');
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error('Có lỗi xảy ra khi tạo thể loại mới');
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
